import React from 'react';
import { useSelector } from 'react-redux';

import FacetFilter from './FacetFilter';

const DealFilters = ({ values, onChange, text }) => {
  const { dealFacetData } = useSelector(({ search }) => search);

  switch (text) {
    case 'Подразделения':
      return (
        <FacetFilter
          text="Подразделения"
          options={dealFacetData?.cashbox}
          values={values}
          onChange={onChange}
        />
      );
    case 'Филиалы':
      return (
          <FacetFilter
              text="Филиалы"
              options={dealFacetData?.branch}
              values={values}
              onChange={onChange}
          />
      );
    case 'Пробы':
      return (
        <FacetFilter
          text="Пробы"
          options={dealFacetData?.purityName}
          values={values}
          onChange={onChange}
        />
      );
    case 'Драг. металлы':
      return (
        <FacetFilter
          text="Драг. металлы"
          options={dealFacetData?.purityType}
          values={values}
          onChange={onChange}
        />
      );
    case 'Тип договора':
      return (
        <FacetFilter
          text="Тип договора"
          options={dealFacetData?.dealType}
          values={values}
          onChange={onChange}
        />
      );
    case 'Статус':
      return (
        <FacetFilter
          text="Статус"
          options={dealFacetData?.status}
          values={values}
          onChange={onChange}
        />
      );
    case 'Марка':
      return (
        <FacetFilter
          text="Марка"
          options={dealFacetData?.carBrand}
          values={values}
          onChange={onChange}
        />
      );
    case 'Год выпуска':
      return (
        <FacetFilter
          text="Год выпуска"
          options={dealFacetData?.carDate}
          values={values}
          onChange={onChange}
        />
      );

    default:
      return null;
  }
};

export default DealFilters;
